import React from 'react';
import styles from './styles.module.scss';

const Preloader = () => (
    <div className={styles.preloaderContainer}>
        <div className={styles.preloader}></div>
    </div>
);

export default Preloader;
